import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { portalApi, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { Palette, Loader2, CheckCircle2 } from "lucide-react";

export default function PortalRestablecer() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [repetir, setRepetir] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [listo, setListo] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== repetir) return setError("Las dos contraseñas no coinciden.");
    setLoading(true);
    try {
      const { data } = await portalApi.post("/portal/password/restablecer", { token, password });
      setListo(data);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-6 bg-background">
      <Card className="rounded-2xl p-9 max-w-md w-full fade-up" data-testid="restablecer-page">
        <div className="h-10 w-10 rounded-xl bg-primary grid place-items-center mb-7">
          <Palette className="h-5 w-5 text-primary-foreground" />
        </div>
        {listo ? (
          <div className="text-center">
            <CheckCircle2 className="h-12 w-12 text-primary mx-auto" />
            <h1 className="font-display text-2xl font-extrabold mt-6">Contraseña actualizada</h1>
            {listo.matricula && (
              <p className="text-sm text-muted-foreground mt-3">
                Entra con tu matrícula <b className="text-foreground">{listo.matricula}</b>.
              </p>
            )}
            <Button asChild className="rounded-full font-semibold mt-8 w-full" data-testid="ir-login-btn">
              <Link to="/">Entrar</Link>
            </Button>
          </div>
        ) : (
          <>
            <h1 className="font-display text-2xl font-extrabold">Crea tu contraseña</h1>
            <p className="text-sm text-muted-foreground mt-2 mb-7">Debe tener al menos 6 caracteres.</p>
            <form onSubmit={submit} className="space-y-5">
              <div className="space-y-2">
                <Label>Nueva contraseña</Label>
                <PasswordInput required minLength={6} value={password}
                  onChange={(e) => setPassword(e.target.value)} className="rounded-lg h-12"
                  data-testid="nueva-password-input" />
              </div>
              <div className="space-y-2">
                <Label>Repite la contraseña</Label>
                <PasswordInput required minLength={6} value={repetir}
                  onChange={(e) => setRepetir(e.target.value)} className="rounded-lg h-12"
                  data-testid="repetir-password-input" />
              </div>
              {error && <p className="text-sm text-destructive font-medium" data-testid="restablecer-error">{error}</p>}
              <Button type="submit" disabled={loading || !token} className="w-full h-12 rounded-full font-semibold"
                data-testid="guardar-password-btn">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Guardar contraseña"}
              </Button>
              {!token && (
                <p className="text-sm text-muted-foreground">
                  El enlace no es válido. Vuelve a pedirlo desde la página de acceso.
                </p>
              )}
            </form>
          </>
        )}
      </Card>
    </div>
  );
}
